import { render } from 'preact';
import { App } from './App';
import './index.css';

// Some sign-in redirects leave this sentinel in the browser URL.
if (window.location.hash === '#_=_') {
  const url = new URL(window.location.href);
  url.hash = '';
  window.history.replaceState(window.history.state, '', url.href);
}

render(<App />, document.getElementById('app'));
